// extracted by mini-css-extract-plugin
export default {"popover":"popover__WBMbr","fullWidth":"fullWidth__uzEdE","expanded":"expanded__yz4UH","header":"header__sD1xn","tablist":"tablist__eRLGw"};